import { all } from 'redux-saga/effects';
import { watchSelect } from './watchSelect'

export default function* rootSaga() {
    yield all([
        watchSelect()
    ])
}